import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const KitstersLayout = () => {
  const userDataString = localStorage.getItem((window as any).APPSETTING?.appname + "user");
  const userData = userDataString && userDataString !== "null" ? JSON.parse(userDataString) : null;
  const useremail = userData?.user?.email;

  return (
    <div className="app-wrapper">
      <nav>
        <div className="nav-inner">
          <Link to="/" className="nav-logo">Sen<span className="dd">dd</span></Link>

          <div className="nav-links">
            <Link to="/">Home</Link>
            <a href="#how">How it Works</a>
            <a href="#pricing">Pricing</a>
            <Link to="/login">Login</Link>
          </div>

          {useremail ? (
            <Link to="/dashboard" className="btn btn-dark">Dashboard</Link>
          ) : (
            <Link to="/login" className="btn btn-dark">Get an API key</Link>
          )}
        </div>
      </nav>

      {/* Defensive spacer — .nav-spacer not yet in CSS, inline height kept as accepted one-off */}
      <div className="nav-spacer" style={{ height: '64px' }}></div>

      <main>
        <Outlet />
      </main>

      <footer>
        <div className="container">
          <p>© {new Date().getFullYear()} senddit.in · Independent developer tool · Not affiliated with WhatsApp or Meta</p>
          <div  style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', fontSize: '0.9rem', opacity: 0.7 }}>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <a href="#contact">Contact</a>
              <a href="#terms">Terms</a>
              <a href="#refunds">Refunds</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default KitstersLayout;
